<template>
  <div style="height: inherit; position: relative; width: 100%">
    <div style="height: calc(100% - 32px); padding: 0 5px">
      <div class="table-container header" ref="tableHeader">
        <table border>
          <colgroup>
            <col width="16px" v-if="filterMultiple" />
            <col
              v-for="(item, index) in columns"
              :key="index"
              :style="{ width: item.width ? item.width + 'px' : '16px' }"
            />
          </colgroup>
          <thead>
            <tr>
              <th v-if="filterMultiple">
                <input type="checkbox" name="" id="" />
              </th>
              <th v-for="(item, index) in columns" :key="index">{{ item.title }}</th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="table-container body" ref="tableBody">
        <table border>
          <colgroup>
            <col width="16px" v-if="filterMultiple" />
            <col
              v-for="(item, index) in columns"
              :key="index"
              :style="{ width: item.width ? item.width + 'px' : '16px' }"
            />
          </colgroup>
          <tr
            v-for="(item, index) in dataSource"
            :key="index"
            :class="tabIndex === index ? 'active' : ''"
            @click="onClick(item, index)"
            @dblclick="onDbClick(item)"
          >
            <td v-if="filterMultiple"><input type="checkbox" name="" id="" @change="onClick(item)" /></td>
            <td
              v-for="(data, index2) in columns"
              :key="index2"
              :title="data.customRender ? data.customRender(item[data['dataIndex']]) : item[data['dataIndex']]"
            >
              <span>
                    {{ data.customRender ? data.customRender(item[data['dataIndex']]) : item[data['dataIndex']] }}
              </span>
              <!-- <slot :name="data.scopedSlots && data.scopedSlots.customRender">
                {{ data.customRender ? data.customRender(item[data['dataIndex']]) : item[data['dataIndex']] }}
              </slot> -->
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="footer" v-if="pagination">
      <div class="footer-btn">
        <a-button type="primary" ghost @click="pro()"> 上一页 </a-button>
        <a-button type="primary" ghost @click="next()"> 下一页 </a-button>
      </div>
      <select name="" id="" v-model="pages.showCount" @change="changeShowCount()">
        <option :value="item" v-for="(item, index) in showCountList" :key="index">{{ item }}条/页</option>
      </select>
      <div>
        <span>跳转至 <input type="text" width="50px" /> 页</span>
        <span>当前是第 {{ pages.currentPage }} 页 共 {{ pages.totalPage }}页</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rowSelection: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    pages: {
      type: Object,
      default: () => {
        return { total: 0, pageIndex: 1, totalPage: 0, showCount: 10, currentPage: 1, index: -1 }
      },
    },
    filterMultiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabIndex: '',
      showCountList: [10, 20, 30, 50, 100, 500, 1000],
    }
  },
  watch: {
    dataSource(v, oldV) {
      if (v.length !== oldV) {
        this.tabIndex = ''
      }
    },
  },
  mounted() {
    var containerDom = this.$refs.tableBody
    const tabHeader = this.$refs.tableHeader
    if (containerDom) {
      var onScroll = function () {
        tabHeader.scrollLeft = containerDom.scrollLeft
      }
      containerDom.addEventListener('scroll', onScroll)
    }
    const clientHeight = document.body.clientHeight
    containerDom.style.maxHeight = clientHeight - 250 + 'px'
  },
  methods: {
    
    checkTr() {},
    pro() {
      this.$emit('pro')
    },
    next() {
      this.$emit('next')
    },
    changeShowCount() {
      this.$emit('changeShowCount', this.pages.showCount)
    },
    onClick(item, index) {
      if (this.rowSelection.onChange) {
        this.tabIndex = index
        this.rowSelection.selectedRowKeys = []
        this.rowSelection.selectedRowKeys.push(item)
        this.rowSelection.onChange(this.rowSelection.selectedRowKeys)
      }
    },
    onDbClick(item) {
      if (this.rowSelection.onDbClick) {
        this.rowSelection.selectedRowKeys = []
        this.rowSelection.selectedRowKeys.push(item)
        this.tabIndex = ''
        this.rowSelection.onDbClick(this.rowSelection.selectedRowKeys)
      }
    },
  },
}
</script>

<style lang="less" scoped>
table {
  border-collapse: collapse;
  width: 100%;
}
table {
  table-layout: fixed;
}

.table-container {
  overflow: auto;
  width: 100%;
  // max-height: calc(100% - 30px);
}

.table-container.header {
  // margin-bottom: -8px;
  padding-bottom: 0px;
  min-width: 17px;
  overflow: scroll;
  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
}
.table-container.body {
  table {
    border-top: hidden;
  }
  tr {
    &:hover {
      background-color: #85aff8;
    }
    // &:focus{
    //   background-color: #85aff8;
    // }
    &.active {
      background-color: #85aff8;
    }
  }
}
th {
  background-color: #cde4f6;
  text-align: center;
}
.footer {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  // position: absolute;
  // bottom: 0;
  background-color: #fff;
  width: 100%;
  .footer-btn {
    button {
      margin: 0 5px;
    }
  }
  select {
    margin: 0 10px;
  }
  &:last-child {
    input {
      width: 50px;
      outline: none;
      border: 1px solid;
    }
    span {
      padding: 0 10px;
    }
  }
}
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
<style lang="less">
.table-container.header::-webkit-scrollbar {
  display: none;
}
.table-container.header {
  scrollbar-width: none;
}
.table-container.header {
  -ms-overflow-style: none;
}
</style>
